import { createFileRoute, useRouter } from '@tanstack/react-router'

import styles from './styles.module.scss'
import DatePicker from '@/components/ui/date-picker'
import { useBoolean } from '@/hooks'
import { cardsServiceInstance } from '@/services/cards.service'
import { useState } from 'react'

export const Route = createFileRoute('/desktop/__app/my-cards/')({
  component: RouteComponent,
  loader: async () => {
    const meCards = await cardsServiceInstance.meCards()
    return meCards
  },
  shouldReload: true,
})

function RouteComponent() {
  const [isOpenDatePicker, handleOpenDatePicker, handleCloseDatePicker] = useBoolean()

  const cards = Route.useLoaderData()
  const router = useRouter()
  const [filterType, setFilterType] = useState<'all' | 'win' | 'lose'>('all')

  const filteredCards = filterType === "lose" ? cards.filter(c => c.cards.some(c => c.value <= 0)).map(c => ({
    title: c.title,
    cards: c.cards.filter(c => c.value <= 0)
  })) : cards

  const newFilters = filterType === "win" ? filteredCards.filter(c => c.cards.some(c => c.value > 0)).map(c => ({
    title: c.title,
    cards: c.cards.filter(c => c.value > 0)
  })) : filteredCards


  return (
    <div className={styles.container}>
      <header>
        <h3>Minhas Cartelas</h3>

        <button onClick={handleOpenDatePicker}>
          <img
            src="/assets/calendar.svg"
          />
        </button>
        <nav className={styles.header_pivot}>
          <button
            className={`${filterType === "all" && styles.active}`}
            onClick={() => setFilterType('all')}
          >
            Todas
          </button>
          <button
            className={`${filterType === "lose" && styles.active}`}
            onClick={() => setFilterType('lose')}
          >
            Não premiadas
          </button>
          <button
            className={`${filterType === "win" && styles.active}`}
            onClick={() => setFilterType('win')}
          >
            Permiadas
          </button>
        </nav>
      </header>
      {
        newFilters.map(section => (
          <div key={section.title}>
            <span>{section.title}</span>
            <ul>
              {
                section.cards.map(c => (
                  <li key={c.id} onClick={() => router.navigate({ to: '/desktop/my-cards/$card', params: { card: c.id } })}>
                    <div>
                      {
                        c.cardBalls.map(ball => (
                          <div key={ball}>
                            {ball}
                          </div>
                        ))
                      }
                    </div>
                  </li>
                ))
              }
            </ul>
          </div>
        ))
      }
      {
        isOpenDatePicker && (
          <DatePicker
            isOpen={isOpenDatePicker}
            // onSelectedDate={date => }
            onClose={handleCloseDatePicker}

          />
        )
      }
    </div>
  )
}
